"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadSetting = exports.saveSetting = void 0;
var settingKey = "starryui:";
/**
 * Save a setting back to local storage
 */
function saveSetting(settingName, value) {
    if (window.localStorage) {
        window.localStorage.setItem(settingKey + settingName, JSON.stringify(value));
    }
}
exports.saveSetting = saveSetting;
/**
 * Load a settings from local storage
 */
function loadSetting(settingName, defaultVal) {
    if (window.localStorage) {
        var val = JSON.parse(window.localStorage.getItem(settingKey + settingName));
        if (val !== null && val !== undefined) {
            return val;
        }
    }
    return defaultVal;
}
exports.loadSetting = loadSetting;
